import React from "react";
import { ORG } from "@/lib/constants";
import { SectionCard } from "@/components/uikit";

const ROWS = [
  ["Organization", ORG.name],
  ["CAGE", ORG.cage],
  ["System", ORG.system],
  ["Framework", ORG.framework],
  ["Architecture", ORG.architecture],
  ["Cryptographic Engine", ORG.crypto],
  ["Analytics", ORG.analytics],
];

// Shared organization / system metadata panel (CAGE 16WJ1 always visible).
export function SystemInfoPanel({ testId = "system-info-card", showPrinciple = true }) {
  return (
    <SectionCard title="System Information" icon="Cpu" testId={testId}>
      <dl className="space-y-2 text-sm">
        {ROWS.map(([k, v]) => (
          <div key={k} className="flex items-center justify-between gap-3 border-b border-slate-900 pb-1.5">
            <dt className="font-mono text-[10px] uppercase tracking-widest text-slate-500">{k}</dt>
            <dd className="text-right text-slate-200">{v}</dd>
          </div>
        ))}
      </dl>
      {showPrinciple && (
        <>
          <p className="mt-3 font-mono text-[10px] uppercase tracking-widest text-slate-500">Operating Principle</p>
          <p className="mt-1 text-xs leading-relaxed text-cyan-300">{ORG.principle}</p>
        </>
      )}
    </SectionCard>
  );
}
